<template lang="pug">
.text-start
  .text.mt-4 Documentação AWS:
  .text.mt-4 KMS:
  a(
    href='https://docs.aws.amazon.com/cli/latest/reference/kms/index.html',
    target='_blank'
  )
    .text.color--info https://docs.aws.amazon.com/cli/latest/reference/kms/index.html
  .text Geração da chave:
  a(
    href='https://docs.aws.amazon.com/cli/latest/reference/kms/create-key.html',
    target='_blank'
  )
    .text.color--info https://docs.aws.amazon.com/cli/latest/reference/kms/create-key.html
  .text Obter chave pública:
  a(
    href='https://docs.aws.amazon.com/cli/latest/reference/kms/get-public-key.html',
    target='_blank'
  )
    .text.color--info https://docs.aws.amazon.com/cli/latest/reference/kms/get-public-key.html
  .text Assinatura:
  a(
    href='https://docs.aws.amazon.com/cli/latest/reference/kms/sign.html',
    target='_blank'
  )
    .text.color--info https://docs.aws.amazon.com/cli/latest/reference/kms/sign.html
  .h6.mt-4 #[strong Chave privada]
  .text.mt-4 Gerar chave RSA 2048 bits:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='keyRSA') $ aws kms create-key --description "
        span.red-background.color--grayscale-dark cert1
        | " --key-usage SIGN_VERIFY --customer-master-key-spec RSA_2048
    Icon#copy-key-rsa.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.keyRSA, 1)',
      @mouseleave='resetContent(1)',
      style='cursor: pointer'
    )
  .text.mt-4 Resultado esperado:
  .code-box.mt-3
    .text {#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"KeyMetadata": {#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"AWSAccountId":
      = ' '
      | "
      span.red-background #{ '<ID da conta AWS>' }
      | "
      | ,#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"KeyId":
      = ' '
      | "
      span.red-background #{ '<ID da chave>' }
      | "
      | ,#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"Arn": "arn:aws:kms:
      = ' '
      span.red-background #{ '<regiao>' }
      | :
      span.red-background #{ '<ID da conta AWS>' }
      | :key/
      span.red-background #{ '<ID da chave>' }
      | ",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"CreationDate": 1654625481.9,#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"Enabled": true,#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"Description":
      | "
      span.red-background cert1
      | ",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"KeyUsage": "SIGN_VERIFY",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"KeyState": "Enabled",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"Origin": "AWS_KMS",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"KeyManager": "CUSTOMER",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"CustomerMasterKeySpec": "RSA_2048",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;"SigningAlgorithms": [#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RSASSA_PKCS1_V1_5_SHA_256",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RSASSA_PKCS1_V1_5_SHA_384",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RSASSA_PKCS1_V1_5_SHA_512",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RSASSA_PSS_SHA_256",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RSASSA_PSS_SHA_384",#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"RSASSA_PSS_SHA_512"#[br]
      | &nbsp;&nbsp;&nbsp;&nbsp;]#[br]
      | &nbsp;&nbsp;}#[br]
      | }#[br]
  h2.mt-5 Assinar termo digital
  .text.mt-4 AWS KMS espera o DIGEST puro a ser assinado, então é preciso extrair essa
    |
    | informação a partir da estrutura PKCS#1 do arquivo
    |        #[span.red-background digitalterm_hash.bin]
  .text.mt-4 Extrair o hash/digest puro do PKCS#1:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='extractHash') $ openssl asn1parse -inform der -in
        = ' '
        span.red-background.color--grayscale-dark digitalterm_hash.bin
    Icon#copy-extract-hash.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.extractHash, 2)',
      @mouseleave='resetContent(2)',
      style='cursor: pointer'
    )
  .text.mt-4 Resultado esperado:
  .code-box.mt-3
    .text 0:d=0 hl=2 l= 47 cons: #[br]
      | 2:d=1 hl=2 l= 11 cons: SEQUENCE#[br]
      | 4:d=2 hl=2 l= 9 prim: OBJECT :sha256#[br]
      | 15:d=1 hl=2 l= 32 prim: OCTET STRING [HEX#[br]
      | DUMP]:
      span.red-background 458A364F84551E45D29B9F2168ED9F2F7347A7ECADBA153C5D47A1150C6662E9
  .text.mt-4 Salve o HEX DUMP em um arquivo
    = ' '
    span.red-background hash.hex
    |
    | e depois converta de hexadecimal para binário
    = ' '
    span.red-background hash.bin
  .text.mt-4 Assinar usando chave privada AWS KMS:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='signAWS') $ aws kms sign --key-id "
        span.red-background.color--grayscale-dark #{ '<ID da chave>' }
        | " --message fileb://
        span.red-background.color--grayscale-dark hash.bin
        = ' '
        | --signing-algorithm RSASSA_PKCS1_V1_5_SHA_256 --message-type DIGEST
    Icon#copy-sign-aws.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.signAWS, 3)',
      @mouseleave='resetContent(3)',
      style='cursor: pointer'
    )
  h2.mt-5 Requisição (CSR)
  .text.mt-4 Gere o CSR na sua aplicação, que fará uso da chave no AWS KMS.
  .text.mt-4 Se a aplicação não der suporte à geração do CSR, gere um CSR no OpenSSL com uma
    |
    | chave qualquer (RSA 2048). Então substitua no CSR a chave pública inserindo a do AWS KMS,
    |
    | e faça nova assinatura do CSR usando a chave privada no AWS KMS.
  .text.mt-4 Essa é uma operação complexa. Recomendamos o uso de um script que faça esse trabalho,
    |
    | como o disponível neste repositório:
    = ' '
    a(href='https://github.com/g-a-d/aws-kms-sign-csr', target='_blank')
      span.text.color--info https://github.com/g-a-d/aws-kms-sign-csr
    br
    |
    | IMPORTANTE: é um repositório público, utilize somente após verificar o código e atestar
    |
    | que é seguro para a sua operação
  .alert.alert-dismissible.alert-warning.mt-3(role='alert')
    .alert__icon
      Icon(name='circle-info')
    .alert__content
      .text #[strong Importante]: É um repositório público, utilize somente após verificar o
        |
        | código e atestar que é seguro para a sua operação.
  .text.mt-4 Mas se preferir o método manual, alguns comandos que podem ser úteis no processo:
  .text.mt-4 Obter a chave pública:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='publicKey')
        | $ aws kms get-public-key --output text --query PublicKey --key-id "
        span.red-background.color--grayscale-dark #{ '<ID da chave>' }
        | "
        | #{ '>' }
        = ' '
        span.red-background.color--grayscale-dark chave_publica_base64
    Icon#copy-public-key.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.publicKey, 4)',
      @mouseleave='resetContent(4)',
      style='cursor: pointer'
    )
  .text.mt-4 Converta de base64 para formato DER:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='base64ToDer') $ base64 --decode
        = ' '
        span.red-background.color--grayscale-dark chave_publica_base64
        = ' '
        | #{ '>' }
        = ' '
        span.red-background.color--grayscale-dark pub_key_der
    Icon#copy-base64-to-der.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.base64ToDer, 5)',
      @mouseleave='resetContent(5)',
      style='cursor: pointer'
    )
  .text.mt-4 Faça a conversão para o formato esperado pelo OpenSSL:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='convertToExpectedFormat') $ openssl rsa -pubin -pubout -inform der -in
        = ' '
        span.red-background.color--grayscale-dark pub_key_der
        = ' '
        | -out
        = ' '
        span.red-background.color--grayscale-dark pub_key
    Icon#copy-convert-to-expected-format.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.convertToExpectedFormat, 6)',
      @mouseleave='resetContent(6)',
      style='cursor: pointer'
    )
  .text.mt-4 Assinar usando chave privada AWS KMS:
  .d-flex.flex-row.mt-3
    .code-box.code-box--with-border
      .text.color--info(ref='signUsingKeyAWS') $ aws kms sign --key-id "
        span.red-background.color--grayscale-dark #{ '<ID da chave>' }
        | "
        = ' '
        | --message#[br]#[br]
        | fileb://
        span.red-background.color--grayscale-dark csr_to_be_signed_der
        = ' '
        | --signing-algorithm#[br]#[br]
        | RSASSA_PKCS1_V1_5_SHA_256 --message-type RAW

    Icon#copy-sign-using-key-aws.ms-3.m-auto(
      name='copy',
      @click='doCopy(this.$refs.signUsingKeyAWS, 7)',
      @mouseleave='resetContent(7)',
      style='cursor: pointer'
    )
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { Tooltip } from 'bootstrap'

  type TooltipType = {
    id: number
    tooltip: Tooltip
  }

  export default defineComponent({
    name: 'GenerateCSRRequestView',
    components: {
      Icon,
    },
    data() {
      return {
        tooltips: [] as TooltipType[],
      }
    },
    mounted() {
      this.tooltips.push({
        id: 1,
        tooltip: new Tooltip('#copy-key-rsa', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 2,
        tooltip: new Tooltip('#copy-extract-hash', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 3,
        tooltip: new Tooltip('#copy-sign-aws', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 4,
        tooltip: new Tooltip('#copy-public-key', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 5,
        tooltip: new Tooltip('#copy-base64-to-der', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 6,
        tooltip: new Tooltip('#copy-convert-to-expected-format', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })

      this.tooltips.push({
        id: 7,
        tooltip: new Tooltip('#copy-sign-using-key-aws', {
          title: 'Clique para copiar',
          placement: 'right',
        }),
      })
    },
    methods: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      async doCopy(ref: any, id: number) {
        await navigator.clipboard.writeText(ref.textContent.replace('$ ', ''))
        this.tooltips
          .find((tooltip) => tooltip.id === id)
          ?.tooltip.setContent({ '.tooltip-inner': 'Código copiado!' })
      },
      resetContent(id: number) {
        this.tooltips
          .find((tooltip) => tooltip.id === id)
          ?.tooltip.setContent({ '.tooltip-inner': 'Clique para copiar' })
      },
    },
  })
</script>
